import { ContentStoreDesignTaggingGuidanceService } from 'src/services/DesignTaggingGuidances';

export const deleteDesignTaggingGuidance = (
    { accessToken, id }: App.DesignTaggingGuidance.DeleteMutationVariables,
): Promise<void> => ContentStoreDesignTaggingGuidanceService.deleteDesignTaggingGuidance(accessToken, id);
